import { queryClient } from "@/lib/queryClient";
import {
  marketingAssetKeys,
  type MarketingAssetEntityType,
} from "./marketingAssets.query-keys";

/** Invalidate marketing-asset queries (refetch active + inactive observers). */
export async function invalidateMarketingAssets(
  boardId: number,
  entityType?: MarketingAssetEntityType,
  entityId?: number,
): Promise<void> {
  const queryKey =
    entityType != null && entityId != null
      ? marketingAssetKeys.entity(boardId, entityType, entityId)
      : marketingAssetKeys.board(boardId);

  await queryClient.invalidateQueries({
    queryKey,
    refetchType: "all",
  });
}
